/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Loader from 'react-loader-spinner'
import { groupBy, isEmpty } from 'lodash'
import { Link } from 'react-router-dom'
import CardContent from '../CardContent'
import {
  getPesticidesRequest, getPesticideFilterRequest,
  resetFilter,
} from '../../../redux-saga/User/AllPesticide/Reducer'
import { getCategoryRequest } from '../../../redux-saga/User/AllCategory/Reducer'
import style from './index.module.css'
import Search from '../../../components/Mobile/Search'
import SpinLoader from '../../../components/Mobile/Loader'
import ErrorMessage from '../../../components/Mobile/ErrorMessage'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'
import Button from '../../../components/Mobile/Button'

const PesticideByCategory = () => {
  const dispatch = useDispatch()
  const [ searchString, setSearchString ] = useState('')
  const [ groupedByCategory, setGroupedByCategory ] = useState({})
  const [ categoryMapById, setCategoryMapById ] = useState({})
  const {
    pesticides, fetching, filterFetching, filteredPesticide,
    isFilterEnabled,
  } = useSelector((state) => state.pesticides)
  const { categories } = useSelector((state) => state.categories)

  useEffect(() => {
    dispatch(getCategoryRequest())
    dispatch(getPesticidesRequest())
  }, [])

  useEffect(() => {
    if (pesticides?.length) {
      setGroupedByCategory(groupBy(pesticides, 'categoryId'))
    }
  }, [ pesticides ])

  useEffect(() => {
    if (categories?.length) {
      const cateMapById = {}
      categories?.forEach((category) => {
        cateMapById[ category.id ] = category
      })
      setCategoryMapById(cateMapById)
    }
  }, [ categories ])

  const onSearch = (e) => {
    const { value } = e.target
    setSearchString(e.target.value)
    if (!value?.length) {
      dispatch(resetFilter())
    }
  }
  const onSearchSubmit = () => {
    dispatch(getPesticideFilterRequest({ text: searchString }))
  }
  const clearSearch = () => {
    setSearchString('')
    dispatch(resetFilter())
  }
  return (
    <>
      <Search
        onSearchChange={ onSearch }
        value={ searchString }
        onSearchHandler={ onSearchSubmit }
        clearSearch={ clearSearch }
      />
      {
        (fetching || filterFetching)
          ? (
            <SpinLoader />
          )
          : (isFilterEnabled && !filterFetching)
            ? (filteredPesticide?.length)
              ? <CardContent pesticides={ filteredPesticide } />
              : <ErrorMessage message='No result found !! Please search with pesticide name, category, brand, season' />
            : (!isEmpty(groupedByCategory))
              ? (
                <div>
                  {Object.keys(groupedByCategory).map((cateId) => (
                    <>
                      <div className={ `p-2 ${ style.cateHead }` }>
                        <Link
                          to={ ROUTE.PESTICIDES }
                        >
                          {categoryMapById[ cateId ]?.name}
                        </Link>
                        <Link to={ ROUTE.PESTICIDES }>Show more >></Link>
                      </div>
                      <CardContent pesticides={ groupedByCategory[ cateId ] } additionalClass={ style.categoryGroup } />
                    </>
                  ))}
                </div>
              )
              : <ErrorMessage message='No result found !! Please refresh this page.' />
      }
    </>
  )
}

export default PesticideByCategory
